module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_26.a9e9bec3.png";